import React from 'react';
import { Button } from '.';
import usePrefix from '@/hooks/usePrefix';
import PageLoader from '../shared/PageLoader';

const BicesterModal = ({
  show,
  loading,
  isInput = false,
  content,
  cancel = '取消',
  confirm = '确定',
  onCancel,
  onConfirm,
}: {
  show: boolean;
  loading?: boolean;
  isInput?: boolean;
  content: React.ReactNode;
  cancel?: string;
  confirm?: string;
  onCancel: () => void;
  onConfirm: () => void;
}) => {
  const { prefix, classname } = usePrefix('bicester-modal');

  return (
    <div className={classname}>
      {(show || loading) && (
        <div className="w-full h-screen fixed top-0 left-0 bg-black bg-opacity-40 flex justify-center items-center z-[999]">
          {loading ? (
            <PageLoader />
          ) : (
            <div className="flex flex-col items-center p-[40px] bg-[#fff]">
              <div
                className={`w-full text-center text-[#999999] text-[16px] ${
                  isInput ? '' : 'py-[35px] px-[10px]'
                }`}
              >
                {content}
              </div>
              <div className="flex justify-between h-[33px] mt-[20px]">
                <Button
                  className={`${prefix('btn')} ${prefix('cancel-btn')} mr-[35px]`}
                  onClick={onCancel}
                >
                  {cancel}
                </Button>
                <Button className={prefix('btn')} onClick={onConfirm}>
                  {confirm}
                </Button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default BicesterModal;
